import Contributors from 'components/Contributors'

const ContributorComponents = () => {
 
  return (
    <Contributors />
  )
}

export default ContributorComponents;